import './ClosedIcons.less';

const BetWonIcon = ({ height = 26, width = 26, closedBet = false }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className="closing-icon"
        >
            <path
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm4.017 3.457a.75.75 0 0 1 .097.974l-.07.086-5 5.25a.75.75 0 0 1-1.024.06l-.077-.075-2.25-2.5a.75.75 0 0 1 1.034-1.08l.08.076 1.708 1.897 4.442-4.662a.75.75 0 0 1 1.06-.026z"
                fill={closedBet ? '#1261A0' : '#32c24d'}
                fillRule="nonzero"
            />
        </svg>
    );
};

export default BetWonIcon;
